import { render, staticRenderFns } from "./VDataFinal.vue?vue&type=template&id=b7f3e44c&"
import script from "./VDataFinal.vue?vue&type=script&lang=js&"
export * from "./VDataFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports